import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiArrowLeft } = FiIcons;

const PrivacyPage = () => (
  <div className="min-h-screen bg-gradient-to-b from-slate-50 to-stone-100 py-16 px-4 sm:px-6 lg:px-8">
    <div className="max-w-4xl mx-auto">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <Link
          to="/"
          className="inline-flex items-center text-amber-700 hover:text-amber-800 mb-8 transition-colors"
        >
          <SafeIcon icon={FiArrowLeft} className="w-4 h-4 mr-2" />
          Zurück zur Startseite
        </Link>

        <div className="bg-gradient-to-r from-amber-50 to-orange-50 px-6 py-8 rounded-t-2xl border border-stone-200">
          <h1 className="text-4xl font-bold text-stone-800">Datenschutzerklärung</h1>
        </div>

        <div className="bg-white p-8 rounded-b-2xl shadow-lg border-l border-r border-b border-stone-200">
          <div className="prose prose-stone max-w-none space-y-6 text-stone-700">
            <section>
              <h2 className="text-xl font-semibold text-stone-800 mb-3">Datenschutz auf einen Blick</h2>
              <h3 className="text-lg font-semibold text-stone-800 mb-2">Allgemeine Hinweise</h3>
              <p>
                Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen oder mit uns in Kontakt treten. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.
              </p>
              <h3 className="text-lg font-semibold text-stone-800 mb-2 mt-4">Wichtiger Hinweis</h3>
              <p>
                Diese Website verwendet keine Cookies und kein Tracking. Wir verzichten bewusst auf Analysedienste wie Google Analytics oder ähnliche Tools.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-stone-800 mb-3">Verantwortliche Stelle</h2>
              <p>Verantwortlich für die Datenverarbeitung auf dieser Website ist:</p>
              <p>
                Nadine Rau<br />
                Yin und Klang<br />
                Bettenhäuser Str. 1<br />
                34123 Kassel<br />
                E-Mail:{' '}
                <a href="mailto:nadine.rau@yin-und-klang.de" className="text-amber-700 hover:underline">
                  nadine.rau@yin-und-klang.de
                </a>
                <br />
                Telefon: 0561 43027276
              </p>
              <p>
                Anbieterin der Website ist die Nadine Rau u. Mike Trepte GbR (
                <Link to="/impressum" className="text-amber-700 hover:underline">
                  siehe Impressum
                </Link>
                ).
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-stone-800 mb-3">Hosting</h2>
              <p>
                Diese Website wird bei Netlify Inc., San Francisco, USA, gehostet. Beim Aufruf der Seite verarbeitet Netlify technisch notwendige Daten wie IP-Adresse, Zeitpunkt des Abrufs und Browsertyp, um die Website auszuliefern und abzusichern. Rechtsgrundlage ist unser berechtigtes Interesse an einem sicheren und zuverlässigen Betrieb der Website (Art. 6 Abs. 1 lit. f DSGVO). Netlify ist nach dem EU-US Data Privacy Framework zertifiziert.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-stone-800 mb-3">Anfrageformular „Platz sichern”</h2>
              <p>Wenn Sie uns über das Formular eine Anfrage senden, verarbeiten wir folgende Daten:</p>
              <ul className="list-disc list-inside space-y-1 ml-4">
                <li>Vor- und Nachname</li>
                <li>E-Mail-Adresse</li>
                <li>Telefonnummer</li>
                <li>Ihren Terminwunsch</li>
                <li>Ihre Nachricht (optional)</li>
              </ul>
              <p>
                Wir nutzen diese Daten, um Ihre Anfrage zu bearbeiten, Ihren Platz zu organisieren und mit Ihnen zu kommunizieren. Sie erhalten automatisch eine Eingangsbestätigung per E-Mail. Rechtsgrundlage ist die Anbahnung bzw. Durchführung eines Vertrags (Art. 6 Abs. 1 lit. b DSGVO).
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-stone-800 mb-3">Weitergabe an Klangzeit Kassel</h2>
              <p>
                Yin und Klang ist ein gemeinsames Angebot von Nadine Rau und Marcella Toby. Vertragspartnerin für alle gebuchten Retreats und Kurse ist Klangzeit Kassel, Marcella Toby, Rubensstraße 6, 34121 Kassel.
              </p>
              <p>
                Damit Ihre Buchung zustande kommt, geben wir Ihre Anfragedaten an Klangzeit Kassel weiter. Von dort erhalten Sie Ihre Buchungsbestätigung und Ihre Rechnung. Wundern Sie sich also nicht, wenn Sie nach Ihrer Anfrage bei Yin und Klang eine E-Mail von Klangzeit Kassel bekommen. Rechtsgrundlage ist die Durchführung des Vertrags (Art. 6 Abs. 1 lit. b DSGVO). Für die Buchungs- und Rechnungsdaten ist Klangzeit Kassel verantwortlich; Informationen dazu finden Sie unter{' '}
                <a
                  href="https://www.klangzeit-kassel.de/datenschutz"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-amber-700 hover:underline"
                >
                  klangzeit-kassel.de/datenschutz
                </a>
                .
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-stone-800 mb-3">Newsletter: Termine und Angebote per E-Mail</h2>
              <p>
                Wenn Sie im Anfrageformular ankreuzen, über neue Termine und Formate informiert zu werden, oder sich über unser Anmeldeformular eintragen, senden wir Ihnen zunächst eine E-Mail mit einem Bestätigungslink (Double-Opt-In). Erst nach Ihrem Klick auf diesen Link werden Sie in unseren Verteiler aufgenommen. Wir speichern dabei den Zeitpunkt der Anmeldung und der Bestätigung sowie die verwendete IP-Adresse, um Ihre Einwilligung nachweisen zu können.
              </p>
              <p>
                Rechtsgrundlage ist Ihre Einwilligung (Art. 6 Abs. 1 lit. a DSGVO). Sie können sie jederzeit widerrufen, über den Abmeldelink in jeder E-Mail oder per E-Mail an{' '}
                <a href="mailto:nadine.rau@yin-und-klang.de" className="text-amber-700 hover:underline">
                  nadine.rau@yin-und-klang.de
                </a>
                . Ihre Daten bleiben gespeichert, bis Sie sich abmelden.
              </p>
              <p>
                Kundinnen und Kunden, die bereits bei uns gebucht haben, informieren wir gelegentlich auch ohne Newsletter-Anmeldung über ähnliche eigene Angebote (§ 7 Abs. 3 UWG, Art. 6 Abs. 1 lit. f DSGVO). Dem können Sie jederzeit widersprechen, ohne dass dafür andere als die Übermittlungskosten nach den Basistarifen entstehen.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-stone-800 mb-3">Verwendete Dienste</h2>

              <h3 className="text-lg font-semibold text-stone-800 mb-2">Brevo</h3>
              <p>
                Für den Versand unserer E-Mails, die Verwaltung der Kontakte und den Newsletter einschließlich Double-Opt-In nutzen wir Brevo (Sendinblue GmbH, Köpenicker Str. 126, 10179 Berlin). Die Daten werden auf Servern in der Europäischen Union verarbeitet. Brevo erfasst, ob eine E-Mail zugestellt werden konnte oder nicht (z. B. bei vollem Postfach oder ungültiger Adresse), sowie, ob sie geöffnet und Links darin angeklickt wurden. Wir nutzen diese Angaben, um den Versand zuverlässig zu halten und ungültige Adressen zu bereinigen. Rechtsgrundlage ist unser berechtigtes Interesse an einem funktionierenden E-Mail-Versand (Art. 6 Abs. 1 lit. f DSGVO) bzw. bei Newslettern Ihre Einwilligung.
              </p>

              <h3 className="text-lg font-semibold text-stone-800 mb-2 mt-4">Boost.space</h3>
              <p>
                Als Datenschnittstelle nutzen wir Boost.space (Boost.space a.s., Tschechien), um Ihre Anfrage automatisch an unsere Systeme weiterzuleiten. Die Verarbeitung erfolgt in der Europäischen Union.
              </p>

              <h3 className="text-lg font-semibold text-stone-800 mb-2 mt-4">Microsoft 365</h3>
              <p>
                Über Microsoft 365 (Microsoft Ireland Operations Ltd., Dublin, Irland) erhalten wir eine interne Benachrichtigung über neue Anfragen. Eine Übermittlung von Daten in die USA kann dabei nicht ausgeschlossen werden; Microsoft ist nach dem EU-US Data Privacy Framework zertifiziert.
              </p>

              <h3 className="text-lg font-semibold text-stone-800 mb-2 mt-4">Nextcloud</h3>
              <p>
                Für die sichere Speicherung und Verwaltung von Terminen, Dokumenten und Kontaktdaten nutzen wir Nextcloud. Die Daten werden ausschließlich auf Servern innerhalb der Europäischen Union verarbeitet.
              </p>

              <p>
                Mit unseren Dienstleistern bestehen, soweit erforderlich, Verträge zur Auftragsverarbeitung nach Art. 28 DSGVO.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-stone-800 mb-3">Links zu Instagram</h2>
              <p>
                Auf unserer Website und in unseren E-Mails verlinken wir auf unser Instagram-Profil. Es handelt sich um einfache Links. Daten werden erst übertragen, wenn Sie einen solchen Link anklicken und Instagram aufrufen.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-stone-800 mb-3">Speicherdauer</h2>
              <p>
                Wir speichern Ihre Daten, solange sie für die Bearbeitung Ihrer Anfrage und die Durchführung Ihrer Buchung erforderlich sind. Newsletter-Daten speichern wir bis zu Ihrer Abmeldung. Daten, für die gesetzliche Aufbewahrungsfristen gelten, etwa steuerrelevante Unterlagen, bewahren wir für die Dauer dieser Fristen auf.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-stone-800 mb-3">Ihre Rechte</h2>
              <p>Sie haben jederzeit das Recht:</p>
              <ul className="list-disc list-inside space-y-1 ml-4">
                <li>Auskunft über Ihre bei uns gespeicherten personenbezogenen Daten zu erhalten</li>
                <li>Berichtigung unrichtiger personenbezogener Daten zu verlangen</li>
                <li>Löschung Ihrer bei uns gespeicherten personenbezogenen Daten zu verlangen</li>
                <li>Einschränkung der Datenverarbeitung zu verlangen</li>
                <li>Widerspruch gegen die Verarbeitung Ihrer Daten zu erheben</li>
                <li>Datenübertragbarkeit zu verlangen</li>
                <li>sich bei einer Datenschutz-Aufsichtsbehörde zu beschweren</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-stone-800 mb-3">Widerruf Ihrer Einwilligung</h2>
              <p>
                Sie können Ihre Einwilligung zur Datenverarbeitung jederzeit per E-Mail an{' '}
                <a href="mailto:nadine.rau@yin-und-klang.de" className="text-amber-700 hover:underline">
                  nadine.rau@yin-und-klang.de
                </a>{' '}
                widerrufen. Der Widerruf berührt nicht die Rechtmäßigkeit der bis zum Widerruf erfolgten Verarbeitung.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-stone-800 mb-3">Kontakt bei Datenschutzfragen</h2>
              <p>
                Bei Fragen zum Datenschutz wenden Sie sich bitte an:<br />
                Nadine Rau<br />
                E-Mail:{' '}
                <a href="mailto:nadine.rau@yin-und-klang.de" className="text-amber-700 hover:underline">
                  nadine.rau@yin-und-klang.de
                </a>
                <br />
                Telefon: 0561 43027276
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-stone-800 mb-3">Aufsichtsbehörde</h2>
              <p>
                Der Hessische Beauftragte für Datenschutz und Informationsfreiheit<br />
                Gustav-Stresemann-Ring 1, 65189 Wiesbaden<br />
                <a
                  href="https://www.datenschutz.hessen.de"
                  className="text-amber-700 hover:underline"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  www.datenschutz.hessen.de
                </a>
              </p>
            </section>

            <p className="pt-4 border-t border-stone-100">Stand: Oktober 2026</p>
          </div>
        </div>
      </motion.div>
    </div>
  </div>
);

export default PrivacyPage;